import React from 'react';
import CollapsibleCard from 'core/components/collapsible-card';

import useStyles from './sub-risk-collapsible-section.styles';

const SubRiskCollapsibleSection = ({ children, ...props }) => {
  const classes = useStyles();
  return (
    <CollapsibleCard
      classes={{
        collapse: classes.collapse,
        container: classes.container,
        content: classes.content,
        iconButtonRoot: classes.iconButtonRoot,
        header: classes.header
      }}
      {...props}
    >
      {children}
    </CollapsibleCard>
  );
};

export default SubRiskCollapsibleSection;
